import { render } from "./BigQueryIntegrationSettings.vue?vue&type=template&id=7648bc67"
import script from "./BigQueryIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./BigQueryIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__